import { API_URI } from '../../constants/env';
import { BaseApiResponse } from '../../types/api.types';
import instance from './axios';

const ENDPOINTS = {
  SETTING_GENERAL: '/settings/general',
};

const getGeneralSetting = () => {
  return instance.get<BaseApiResponse>(ENDPOINTS.SETTING_GENERAL);
};

const SettingsApi = {
  getGeneralSetting,
};

export default SettingsApi;
